import React, { useEffect } from "react";
import moment from "jalali-moment";
import "./ArchiveItem.css";
function ArchiveItem(props) {
    // useEffect(() => {
    //     var text = props.text;
    //     text = text.replace(/(<([^>]+)>)/gi, "");
    //     console.log(text);
    //     document.getElementById("text").innerHTML = text;
    // }, []);

    return (
        <div className="archiveItemComp" style={{ width: props.width }}>
            <img alt={props.alt} src={props.image} />
            <div style={{ marginRight: "-5px" }}>
                <h3>{props.title}</h3>
            </div>
            <p id="text">{props.text.replace(/(<([^>]+)>)/gi, "")}</p>
            <div className="infoTimesBlogItemArchive" style={{ justifyContent: "flex-start" }}>
                <span style={{ marginLeft: "8px" }}>نوشته شده در :</span>
                {props.date !== "" ? <span>{moment(props.date).locale("fa").format("YYYY/MM/DD")}</span> : <span></span>}
            </div>
        </div>
    );
}

export default ArchiveItem;
